<template>
  <div class="app-auth">
    <image-bg :image="'bg' + (Math.floor(Math.random() * 7) + 1) + '.jpg'"></image-bg>
    <div class="container-login">

      <div class="logo">Wtis</div>

      <div class="d-t">

        <div class="d-r">

          <div class="d-c left">
            <div class="timer">
              <h1>{{ nowTime }}</h1>
              <h2>{{ nowDate }}</h2>
            </div>
          </div>

          <div class="d-c r">
            <div class="login-tab">
              <ul class="options">
                <li :class="{'selected': selected === 'colaborador'}">
                  <a href="#" @click.prevent="handleSelected('colaborador')" data-class="simple">Colaborador</a>
                </li>
                <li :class="{'selected': selected === 'consultaReboque'}">
                  <a href="#" @click.prevent="handleSelected('consultaReboque')" data-class="dev">Consulta Reboque</a>
                </li>
              </ul>
              <div class="clearfloat"></div>
              <div class="hdiv"></div>
                            <div class="pcontent">
                                <!-- if error -->
                                <div v-if="null !== loginErrorData" class="login-errors">
                                    <div>{{ loginErrorData }}</div>
                                </div>
                                <!-- endif -->
                                <div id="login1">
                                    <Login @error="loginError" :channel="selected"/>
                                </div>

                                <div id="login2">
                                    <form class="form-login" action="" method="post" novalidate>
                                        <input type="hidden" name="_csrf_token" value=" csrf_token "/>
                                        <label style="display:block; clear:both; width:100%;font-family:Arial, Helvetica, sans-serif;font-size:11px;"
                                               data-sr="enter wait 0.8s" class="reveal1">Por favor aguarde</label>
                                        <label style="display:block; clear:both; width:100%;margin-top:-10px;font-family:Arial, Helvetica, sans-serif;font-size:11px;"
                                               data-sr="enter wait 2.2s" class="reveal2">
                                            app.request.server.get("REMOTE_ADDR") request connection</label>
                                        <label for="username2" data-sr="enter wait 2.6s" class="reveal3">Logar
                                            como:</label>
                                        <input type="text" id="username2" name="_username" value="" placeholder=""
                                               class="input-login username" autocomplete="off" required/>

                                        <div class="reveal4">
                                            <label for="password2">Senha:</label>
                                            <input type="password" id="password2" name="_password"
                                                   class="input-login password" placeholder="" required/>
                                        </div>

                                        <label style="display:block; clear:both; width:100%;margin-top:-10px;font-family:Arial, Helvetica, sans-serif;font-size:11px; visibility:hidden"
                                               data-sr="enter wait 2.2s" class="reveal5">Mais um momento por
                                            favor</label>
                                        <button type="submit" class="btn-login">Entrar</button>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="text-bottom-left"><a href="#" class="recover-pw">Esqueci meu acesso</a>
                <!-- | <a href="#" class="recover-pw">Não tenho cadastro</a>--></div>
            <div class="text-bottom-right"><a href="https://www.wtis.com.br" target="_blank" class="sponsored">Desenvolvido por Wtis</a></div>

        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Login from './Forms/Login'
  import _base from '../../_default/components/_base.vue'
  import ImageBg from './ImageBg'

  var moment = require('moment')

  export default {
    name: 'auth',
    components: {Login, ImageBg},
    extends: _base,
    data () {
      this.now = moment().locale('pt-BR')
      return {
        nowTime: this.now.format('HH:mm'),
        nowDate: this.now.format('ddd, DD [DE] MMM', 'pt_BR'),
        loginErrorData: null,
        selected: 'colaborador'
      }
    },
    mounted () {
//      this.$store.commit('APP/SHOW_HEADER', false)
//      this.$store.commit('APP/SHOW_MENU', false)
      this._showHeader(false)
      this._showMenu(false)
      this.$nextTick(() => {
        this.timeInterval = setInterval(this.updateTime, 1000)
      })
    },
    methods: {
      updateTime () {
        this.now = moment().locale('pt-BR')
        this.nowTime = this.now.format('HH:mm')
        this.nowDate = this.now.format('ddd, DD [DE] MMM', 'pt_BR')
      },
      loginError (error) {
        this.loginErrorData = error.detail
      },
      handleSelected (selected) {
        this.selected = selected
        this.loginErrorData = null
      }
    },
    computed: {
      ...mapGetters(['isLogged'])
    }
  }
</script>



// WEBPACK FOOTER //
// Main.vue?6ef09922